import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { logoutUserRequest, logoutUserSuccess, logoutUserFailure } from '../reducers/login';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/logout`;

function* logoutFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { token } = state.loginReducer;
  const response = yield call(() =>
    axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        token,
      },
    }),
  );

  return response;
}

function* workerLogoutSaga() {
  try {
    const response = yield call(logoutFunctionAxios);

    const responseFromLogout = response.data;
    if (response.status === 200) {
      yield put(logoutUserSuccess(responseFromLogout));
    }

    if (response.status === 205) {
      yield put(logoutUserFailure('Email does not exist'));
    }

    if (response.status === 206) {
      yield put(logoutUserFailure('Sorry, the user cannot be logged out'));
    }

    if (response.status === 500) {
      yield put(logoutUserFailure(response.statusText));
    }
  } catch (error) {
    yield put(logoutUserFailure(error));
  }
}

export function* watcherLogoutSaga() {
  yield takeLatest(logoutUserRequest().type, workerLogoutSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_logout.js